module.exports = __webpack_public_path__ + "media/images/athletes/3275-8cecf2f8bffa45d6d4004e24f61147cf.png";